// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.InternalVacancies-step1 {
  margin: 50px 0;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.InternalVacancies-step1 .card {
  border-radius: 15px;
  position: relative;
  width: 56vw;
  height: 100%;
  background: #f7f7f7;
}
.InternalVacancies-step1 .card .card-header {
  border-radius: 15px 15px 0 0;
  background: #f0f0f2;
}
.InternalVacancies-step1 .card .card-header span {
  font-weight: bold;
  font-size: 12px;
  margin: 0 15px;
  color: #52515b;
}
.InternalVacancies-step1 .card .card-header svg {
  color: #a2a1ab;
}
.InternalVacancies-step1 .card .card-header .text-progress {
  margin: 0;
  padding: 0 5px;
  width: 100px;
}
.InternalVacancies-step1 .card .card-header .col-1 {
  justify-content: flex-start;
}
.InternalVacancies-step1 .card .card-body {
  padding: 50px;
  padding-bottom: 20px;
}
.InternalVacancies-step1 .card .card-body .card-white {
  width: 100% px;
  background: white;
  border: 1px solid #3fc3fd;
  border-radius: 15px;
  box-shadow: 0 5px 8px rgba(0, 0, 0, 0.1);
  padding: 15px;
}
.InternalVacancies-step1 .card .card-body .card-white h4 {
  font-size: 15px;
  font-weight: bold;
  margin-top: 5px;
}
.InternalVacancies-step1 .card .card-body .card-white h6 {
  font-size: 14px;
  margin-top: 15px;
}
.InternalVacancies-step1 .card .card-body .card-white input, .InternalVacancies-step1 .card .card-body .card-white select {
  border-radius: 5px !important;
  border: 1.5px solid #3fc3fd !important;
  width: 100%;
  height: 50px;
  padding: 0 5px;
}
.InternalVacancies-step1 .card .card-body .btn-back {
  margin: 0 10px;
  width: 80px;
  height: 30px;
  border: 2px solid #3fc3fd;
  background: none;
  border-radius: 50rem;
  color: #3fc3fd;
  display: flex;
  align-items: center;
  justify-content: center;
}
.InternalVacancies-step1 .card .card-body .btn-next {
  margin: 0 10px;
  width: 80px;
  height: 30px;
  border: none;
  background: linear-gradient(90deg, rgb(64, 194, 255) 0%, rgb(51, 215, 217) 100%);
  border-radius: 50rem;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
}
.InternalVacancies-step1 .card .logo {
  position: absolute;
  top: -18px;
  right: -18px;
  width: 50px;
  height: 50px;
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-radius: 50rem;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background: white;
}
.InternalVacancies-step1 .card .logo img {
  border-radius: 50rem;
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/Views/Service/Views/InternalVacancies/Vacantes/Step1/step.sass"],"names":[],"mappings":"AAAA;EACI,cAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AACJ;AACI;EACI,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;AACR;AACQ;EACI,4BAAA;EACA,mBAAA;AACZ;AACY;EACI,iBAAA;EACA,eAAA;EACA,cAAA;EACA,cAAA;AAChB;AACY;EACI,cAAA;AAChB;AACY;EACI,SAAA;EACA,cAAA;EACA,YAAA;AAChB;AACY;EACI,2BAAA;AAChB;AACQ;EACI,aAAA;EACA,oBAAA;AACZ;AACY;EACI,cAAA;EACA,iBAAA;EACA,yBAAA;EACA,mBAAA;EACA,wCAAA;EACA,aAAA;AAChB;AACgB;EACI,eAAA;EACA,iBAAA;EACA,eAAA;AACpB;AACgB;EACI,eAAA;EACA,gBAAA;AACpB;AACgB;EACI,6BAAA;EACA,sCAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AACpB;AACY;EACI,cAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,gBAAA;EACA,oBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAChB;AACY;EACI,cAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,gFAAA;EACA,oBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAChB;AACQ;EACI,kBAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,sCAAA;EACA,oBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;AACZ;AACY;EACI,oBAAA;EACA,WAAA;AAChB","sourcesContent":[".InternalVacancies-step1\n    margin: 50px 0\n    width: 100%\n    display: flex\n    align-items: center\n    justify-content: center\n\n    .card\n        border-radius: 15px\n        position: relative\n        width: 56vw\n        height: 100%\n        background: #f7f7f7\n\n        .card-header\n            border-radius: 15px 15px 0 0\n            background: #f0f0f2\n\n            span\n                font-weight: bold\n                font-size: 12px\n                margin: 0 15px\n                color: #52515b\n\n            svg\n                color: #a2a1ab\n\n            .text-progress\n                margin: 0\n                padding: 0 5px\n                width: 100px\n\n            .col-1\n                justify-content: flex-start\n\n        .card-body\n            padding: 50px\n            padding-bottom: 20px\n\n            .card-white\n                width: 100%px\n                background: white\n                border: 1px solid #3fc3fd\n                border-radius: 15px\n                box-shadow: 0 5px 8px rgba(0,0,0,.1)\n                padding: 15px\n\n                h4\n                    font-size: 15px\n                    font-weight: bold\n                    margin-top: 5px\n\n                h6\n                    font-size: 14px\n                    margin-top: 15px\n\n                input, select\n                    border-radius: 5px !important\n                    border: 1.5px solid #3fc3fd !important\n                    width: 100%\n                    height: 50px\n                    padding: 0 5px\n\n            .btn-back\n                margin: 0 10px\n                width: 80px\n                height: 30px\n                border: 2px solid #3fc3fd\n                background: none\n                border-radius: 50rem\n                color: #3fc3fd\n                display: flex\n                align-items: center\n                justify-content: center\n\n            .btn-next\n                margin: 0 10px\n                width: 80px\n                height: 30px\n                border: none\n                background: linear-gradient(90deg, rgba(64,194,255,1) 0%, rgba(51,215,217,1) 100%)\n                border-radius: 50rem\n                color: white\n                display: flex\n                align-items: center\n                justify-content: center\n\n        .logo\n            position: absolute\n            top: -18px\n            right: -18px\n            width: 50px\n            height: 50px\n            border: 1px solid rgba(0,0,0,.125)\n            border-radius: 50rem\n            overflow: hidden\n            display: flex\n            align-items: center\n            justify-content: center\n            background: white\n\n            img\n                border-radius: 50rem\n                width: 100%\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
